<template>
  <div class="kcm-group-companies">
    <div class="companies-header" v-if="$route.query.c">
      <h2 class="text-light">{{ companies[selectedCompany].name }}</h2>
      <div class="companies-header-buttons">
        <!-- <a class="contacts-header-form-button" @click="scrollIntoForm()">
          <span class="kcm text-light">V</span>
        </a>-->
        <router-link to="/kcm-group" class="companies-close">
          <span class="kcm text-light">J</span>
        </router-link>
      </div>
    </div>
    <div class="kcm-group-companies-content">
      <div class="column">
        <!-- NAV -->
        <Nav :companies="companies" />
        <!-- IMAGE -->
        <template v-for="(c, i) in companies">
          <transition
            :name="`slide-${direction}`"
            mode="out-in"
            :key="`bg-transition-${i}`"
          >
            <div
              v-if="$route.query.c == i + 1"
              class="company-img desktop"
              :key="`bg-${i}`"
              :style="{ backgroundImage: `url(${c.img})` }"
            ></div>
          </transition>
          <transition
            :name="`slide-${directionMobile}`"
            mode="out-in"
            :key="`bg-transition-${i}`"
          >
            <div
              v-if="$route.query.c == i + 1"
              class="company-img mobile"
              :key="`bg-${i}`"
              :style="{ backgroundImage: `url(${c.imgM})` }"
            ></div>
          </transition>
        </template>
      </div>
      <div class="column">
        <div class="company-inner" v-if="companies[selectedCompany]">
          <ContactFormHeader
            class="desktop"
            v-if="$route.query.c"
            :company="companies[selectedCompany].name"
            :title="companies[selectedCompany].title"
            :email="companies[selectedCompany].email"
            :contacts="companies[selectedCompany].contacts"
          />
          <div
            class="company-inner-content"
            v-if="$route.query.c"
            :class="{ 'company-inner-content-hidden': $route.query.contacts }"
          >
            <template v-if="companies[selectedCompany].texts">
              <p
                v-for="(t, i) in companies[selectedCompany].texts"
                :key="`texts-${i}`"
                v-html="t"
              ></p>
            </template>
            <div class="people" v-if="companies[selectedCompany].people">
              <header>
                <a
                  v-for="(p, i) in companies[selectedCompany].people"
                  :key="`people-tab-${i}`"
                  :class="{ 'active-tab': activeTab === i }"
                  @click="activeTab = i"
                  >{{ p.title }}</a
                >
              </header>
              <div class="people-content">
                <div
                  class="people-item"
                  v-for="(p, i) in companies[selectedCompany].people[activeTab]
                    .list"
                  :key="`people-item-${i}`"
                >
                  <div
                    class="people-img"
                    :style="{ backgroundImage: `url(${p.img})` }"
                  ></div>
                  <!-- <div class="text-group"> -->
                  <p>{{ p.name }}</p>
                  <span>{{ p.position }}</span>
                  <!-- </div> -->
                </div>
              </div>
            </div>
            <template v-if="companies[selectedCompany].textsBottom">
              <p
                v-for="(t, i) in companies[selectedCompany].textsBottom"
                :key="`textsBottom-${i}`"
                v-html="t"
              ></p>
            </template>
          </div>
        </div>
        <ContactFormHeader
          class="mobile"
          v-if="$route.query.c"
          :company="companies[selectedCompany].name"
          :title="companies[selectedCompany].title"
          :email="companies[selectedCompany].email"
          :contacts="companies[selectedCompany].contacts"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    Nav: () => import("./companies/Nav"),
    ContactFormHeader: () => import("./companies/ContactFormHeader"),
  },
  watch: {
    "$route.query"(to, from) {
      if (to.c && from.c) {
        this.direction = parseInt(to.c) > parseInt(from.c) ? "top" : "bottom";
        this.directionMobile =
          parseInt(to.c) > parseInt(from.c) ? "left" : "right";
      }

      this.previous = this.$route.query.c;
      this.selectedCompany = +this.$route.query.c - 1;
      this.activeTab = 0;
    },
  },
  data() {
    return {
      activeTab: 0,
      direction: "top",
      directionMobile: "left",
      selectedCompany: 0,
      companies: [
        // KCM AD
        {
          img: require(`../../assets/img/kcm_group/companies/1/bg.jpg`),
          imgM: require(`../../assets/img/kcm_group/companies/1.jpg`),
          name: this.$t("kcm-companies-1-name"),
          url: "/kcm-group?page=companies&c=1",
          title: this.$t("kcm-companies-1-title"),
          texts: this.$t("kcm-companies-1-texts"),
          textsBottom: this.$t("kcm-companies-1-texts-bottom"),
          email: "KCM.AD@kcm.bg",
          contacts: [
            {
              address: {
                url: "https://goo.gl/maps/HvTphJCd78t",
                text: this.$t("kcm-companies-1-contacts-1"),
              },
            },
            {
              secretary: {
                url: "tel:+35932609464",
                text: "+359 32 609 464",
              },
              'purchases-placement': {
                url: "tel:+359609689",
                text: "+359 609 689",
              },
              // hr: {
              //   url: "tel:+359609281",
              //   text: "+359 609 281",
              // },
              'public-relations': {
                url: "tel:+359609262",
                text: "+359 609 262",
              },
              email: {
                url: "mailto:KCM.AD@kcm.bg",
                text: "KCM.AD@kcm.bg",
              },
            },
          ],
          people: [
            {
              title: this.$t("kcm-group-companies-3"),
              list: [
                {
                  img: require("../../assets/img/kcm_group/companies/1/tsonev.jpg"),
                  name: this.$t("kcm-companies-1-ppl-1-name"),
                  position: this.$t("kcm-companies-1-ppl-1-position"),
                },
                {
                  img: require("../../assets/img/kcm_group/companies/1/s_pehlivanov.jpg"),
                  name: this.$t("kcm-companies-1-ppl-5-name"),
                  position: this.$t("kcm-companies-1-ppl-6-position"),
                },
                {
                  img: require("../../assets/img/kcm_group/companies/1/g.sabev.jpg"),
                  name: this.$t("kcm-companies-1-ppl-14-name"),
                  position: this.$t("kcm-companies-2-ppl-1-position-2"),
                },
              ],
            },
            {
              title: this.$t("kcm-group-companies-4"),
              list: [
                {
                  img: require("../../assets/img/kcm_group/companies/1/m_gurkopashova.jpg"),
                  name: this.$t("kcm-companies-1-ppl-8-name"),
                  position: this.$t("kcm-companies-1-ppl-3-position-new"),
                },
                {
                  img: require("../../assets/img/kcm_group/companies/1/s_stoichev.jpg"),
                  name: this.$t("kcm-companies-1-ppl-6-name"),
                  position: this.$t("kcm-companies-1-ppl-6-position"),
                },
                {
                  img: require("../../assets/img/kcm_group/companies/1/i_dobrev.jpg"),
                  name: this.$t("kcm-companies-1-ppl-2-name"),
                  position: this.$t("kcm-companies-1-ppl-10-position-1"),
                },
                // {
                //   img: require("../../assets/img/kcm_group/companies/1/m_gurkopashova.jpg"),
                //   name: this.$t("kcm-companies-1-ppl-8-name"),
                //   position: this.$t("kcm-companies-1-ppl-10-position"),
                // },
                {
                  img: require("../../assets/img/kcm_group/companies/1/g_angelov.jpg"),
                  name: this.$t("kcm-companies-1-ppl-12-name"),
                  position: this.$t("kcm-companies-1-ppl-10-position"),
                },
                {
                  img: require("../../assets/img/kcm_group/companies/1/p_semerdjiev.jpg"),
                  name: this.$t("kcm-companies-1-ppl-10-name"),
                  position: this.$t("kcm-companies-1-ppl-10-position"),
                },
                {
                  img: require("../../assets/img/kcm_group/companies/1/n_starev.jpg"),
                  name: this.$t("kcm-companies-1-ppl-13-name"),
                  position: this.$t("kcm-companies-1-ppl-10-position"),
                },
                {
                  img: require("../../assets/img/kcm_group/companies/2/d_cherniaev.jpg"),
                  name: this.$t("kcm-companies-2-ppl-1-name"),
                  position: this.$t("kcm-companies-1-ppl-10-position"),
                },
              ],
            },
            {
              title: this.$t("kcm-group-companies-5"),
              list: [
                {
                  img: require("../../assets/img/kcm_group/companies/1/i_dobrev.jpg"),
                  name: this.$t("kcm-companies-1-ppl-2-name"),
                  position: this.$t("kcm-group-companies-3-1"),
                },
                {
                  img: require("../../assets/img/kcm_group/companies/1/p_semerdjiev.jpg"),
                  name: this.$t("kcm-companies-1-ppl-10-name"),
                  position: this.$t("kcm-companies-1-ppl-10-position-2"),
                },
                {
                  img: require("../../assets/img/kcm_group/companies/1/s_stoichev.jpg"),
                  name: this.$t("kcm-companies-1-ppl-6-name"),
                  position: this.$t("kcm-companies-1-ppl-6-position-2"),
                },
                // {
                //   img: require("../../assets/img/kcm_group/companies/1/y_kehayov.jpg"),
                //   name: this.$t("kcm-companies-1-ppl-9-name"),
                //   position: this.$t("kcm-companies-1-ppl-9-position"),
                // },
                // {
                //   img: require("../../assets/img/kcm_group/companies/1/m_chalakov.jpg"),
                //   name: this.$t("kcm-companies-1-ppl-4-name"),
                //   position: this.$t("kcm-companies-1-ppl-4-position-1"),
                // },
              ],
            },
          ],
        },
        //KCM TRADE
        {
          img: require(`../../assets/img/kcm_group/companies/2/bg.jpg`),
          imgM: require(`../../assets/img/kcm_group/companies/2.jpg`),
          name: this.$t("kcm-companies-2-name"),
          title: this.$t("kcm-companies-2-title"),
          texts: this.$t("kcm-companies-2-texts"),
          url: "/kcm-group?page=companies&c=2",
          email: "trade@kcm.bg",
          contacts: [
            {
              title: this.$t("kcm-companies-2-contacts-1"),
              phone: {
                url: "tel:+35932623591",
                text: "+359 32 623 591",
              },
              email: {
                url: "mailto:trade@kcm.bg",
                text: "trade@kcm.bg",
              },
            },
          ],
          people: [
            {
              title: this.$t("kcm-group-companies-5"),
              list: [
                {
                  img: require("../../assets/img/kcm_group/companies/2/d_cherniaev.jpg"),
                  name: this.$t("kcm-companies-2-ppl-1-name"),
                  position: this.$t("kcm-companies-2-ppl-1-position"),
                },
              ],
            },
          ],
        },
        //KCM TEHNO
        {
          img: require(`../../assets/img/kcm_group/companies/3/bg.jpg`),
          imgM: require(`../../assets/img/kcm_group/companies/3.jpg`),
          name: this.$t("kcm-companies-3-name"),
          title: this.$t("kcm-companies-3-title"),
          texts: this.$t("kcm-companies-3-texts"),
          url: "/kcm-group?page=companies&c=3",
          email: "KCM.Technology@kcm.bg",
          contacts: [
            {
              address: {
                url: "https://goo.gl/maps/HvTphJCd78t",
                text: this.$t("kcm-companies-3-contacts-1"),
              },
              phone: {
                url: "tel:+35932609644",
                text: "+359 32 609 644 ",
              },
              email: {
                url: "mailto:KCM.Technology@kcm.bg",
                text: "KCM.Technology@kcm.bg",
              },
            },
          ],
          people: [
            {
              title: this.$t("kcm-group-companies-5"),
              list: [
                {
                  img: require("../../assets/img/kcm_group/companies/3/g_Angelov.jpg"),
                  name: this.$t("kcm-companies-3-ppl-1-name"),
                  position: this.$t("kcm-companies-3-ppl-1-position"),
                },
              ],
            },
          ],
        },
        //KIS EOOD
        {
          img: require(`../../assets/img/kcm_group/companies/4/bg.jpg`),
          imgM: require(`../../assets/img/kcm_group/companies/4.jpg`),
          name: this.$t("kcm-companies-4-name"),
          title: this.$t("kcm-companies-4-title"),
          texts: this.$t("kcm-companies-4-texts"),
          url: "/kcm-group?page=companies&c=4",
          email: "office_is@kcm.bg",
          contacts: [
            {
              address: {
                url: "https://goo.gl/maps/HvTphJCd78t",
                text: this.$t("kcm-companies-4-contacts-1"),
              },
              website: {
                url: "http://www.complex-industrial-service.com/",
                text: this.$t("kcm-companies-4-contacts-2"),
              },
            },
            {
              phone: {
                url: "tel:+35932609778",
                text: "+359 32 609 778",
              },
              email: {
                url: "mailto:office_is@kcm.bg",
                text: "office_is@kcm.bg",
              },
            },
          ],
          people: [
            {
              title: this.$t("kcm-group-companies-5"),
              list: [
                {
                  img: require("../../assets/img/kcm_group/companies/4/a_konov.jpg"),
                  name: this.$t("kcm-companies-4-ppl-1-name"),
                  position: this.$t("kcm-companies-4-ppl-1-position"),
                },
              ],
            },
          ],
        },
        //METALURGREMONT
        {
          img: require(`../../assets/img/kcm_group/companies/5/bg.jpg`),
          imgM: require(`../../assets/img/kcm_group/companies/5.jpg`),
          name: this.$t("kcm-companies-5-name"),
          title: this.$t("kcm-companies-5-title"),
          texts: this.$t("kcm-companies-5-texts"),
          url: "/kcm-group?page=companies&c=5",
          email: "Metalurgremont21@kcm.bg",
          contacts: [
            {
              address: {
                url: "https://goo.gl/maps/HvTphJCd78t",
                text: this.$t("kcm-companies-5-contacts-1"),
              },
            },
            {
              phone: {
                url: "tel:+35932609623",
                text: "+359 32 609 623",
              },
              email: {
                url: "mailto:Metalurgremont21@kcm.bg",
                text: "Metalurgremont21@kcm.bg",
              },
            },
          ],
          people: [
            {
              title: this.$t("kcm-group-companies-4-1"),
              list: [
                {
                  img: require("../../assets/img/kcm_group/companies/5/n_kazakov.jpg"),
                  name: this.$t("kcm-companies-5-ppl-1-name"),
                  position: this.$t("kcm-companies-1-ppl-3-position"),
                },
                {
                  img: require("../../assets/img/kcm_group/companies/1/p_semerdjiev.jpg"),
                  name: this.$t("kcm-companies-1-ppl-10-name"),
                  position: this.$t("kcm-group-companies-4-2"),
                },
                // {
                //   img: require("../../assets/img/kcm_group/companies/3/m_chalakov.jpg"),
                //   name: this.$t("kcm-companies-1-ppl-4-name"),
                //   position: this.$t("kcm-group-companies-4-2"),
                // },
                {
                  img: require("../../assets/img/kcm_group/companies/5/cv_todorov.jpg"),
                  name: this.$t("kcm-companies-5-ppl-2-name"),
                  position: this.$t("kcm-group-companies-4-2"),
                },
              ],
            },
            {
              title: this.$t("kcm-group-companies-3-1"),
              list: [
                {
                  img: require("../../assets/img/kcm_group/companies/5/n_kazakov.jpg"),
                  name: this.$t("kcm-companies-5-ppl-1-name"),
                  position: this.$t("kcm-companies-5-ppl-1-position"),
                },
              ],
            },
          ],
        },
        // STOPANSKI DEINOSTI
        {
          img: require(`../../assets/img/kcm_group/companies/6/bg.jpg`),
          imgM: require(`../../assets/img/kcm_group/companies/6.jpg`),
          name: this.$t("kcm-companies-6-name"),
          title: this.$t("kcm-companies-6-title"),
          texts: this.$t("kcm-companies-6-texts"),
          url: "/kcm-group?page=companies&c=6",
          email: "Stopanski.deinosti@kcm.bg",
          contacts: [
            {
              address: {
                url: "https://goo.gl/maps/HvTphJCd78t",
                text: this.$t("kcm-companies-6-contacts-1"),
              },
            },
            {
              phone: {
                url: "tel:+35932609471",
                text: "+359 32 609 471",
              },
              email: {
                url: "mailto:Stopanski.deinosti@kcm.bg",
                text: "Stopanski.deinosti@kcm.bg",
              },
            },
          ],
          people: [
            {
              title: this.$t("kcm-group-companies-5"),
              list: [
                {
                  // img: require("../../assets/img/kcm_group/companies/6/i_piskova.jpg"),
                  img: require("../../assets/img/kcm_group/companies/5/i_boinovski.jpg"),
                  name: this.$t("kcm-companies-6-ppl-1-name"),
                  position: this.$t("kcm-companies-6-ppl-1-position"),
                },
              ],
            },
          ],
        },
        //STROISERVIZ
        {
          img: require(`../../assets/img/kcm_group/companies/7/bg.jpg`),
          imgM: require(`../../assets/img/kcm_group/companies/7.jpg`),
          name: this.$t("kcm-companies-7-name"),
          title: this.$t("kcm-companies-7-title"),
          texts: this.$t("kcm-companies-7-texts"),
          url: "/kcm-group?page=companies&c=7",
          email: "Stroyservice@kcm.bg ",
          contacts: [
            {
              address: {
                url: "https://goo.gl/maps/HvTphJCd78t",
                text: this.$t("kcm-companies-7-contacts-1"),
              },
            },
            {
              phone: {
                url: "tel:+35932609563",
                text: "+359 32 609 563",
              },
              email: {
                url: "mailto:Stroyservice@kcm.bg",
                text: "Stroyservice@kcm.bg",
              },
            },
          ],
          people: [
            {
              title: this.$t("kcm-group-companies-5"),
              list: [
                {
                  img: require(`../../assets/img/kcm_group/companies/7/v_choinev.jpg`),
                  name: this.$t("kcm-companies-7-ppl-1-name"),
                  position: this.$t("kcm-companies-7-ppl-1-position"),
                },
              ],
            },
          ],
        },
        //INDUSTRIAL ZONE
        {
          img: require(`../../assets/img/kcm_group/companies/8/bg.jpg`),
          imgM: require(`../../assets/img/kcm_group/companies/8.jpg`),
          name: this.$t("kcm-companies-8-name"),
          title: this.$t("kcm-companies-8-title"),
          texts: this.$t("kcm-companies-8-text"),
          url: "/kcm-group?page=companies&c=8",
          email: "anelia.dimitrova@kcm.bg",
          contacts: [
            {
              address: {
                url: "https://goo.gl/maps/HvTphJCd78t",
                text: this.$t("kcm-companies-8-contacts-1"),
              },
            },
            {
              phone: {
                url: "tel:+35932609613",
                text: "+359 32 609 613",
              },
              GSM: {
                url: "tel:+359888656497",
                text: "+359 888 656 497",
              },
              email: {
                url: "mailto:anelia.dimitrova@kcm.bg",
                text: "anelia.dimitrova@kcm.bg",
              },
            },
          ],
          people: [
            {
              title: this.$t("kcm-group-companies-5"),
              list: [
                {
                  img: require(`../../assets/img/kcm_group/companies/8/a_dmitrova.jpg`),
                  name: this.$t("kcm-companies-8-ppl-1-name"),
                  position: this.$t("kcm-companies-8-ppl-1-position"),
                },
              ],
            },
          ],
        },
        //LInvest
        {
          img: require(`../../assets/img/kcm_group/companies/9/bg.jpg`),
          imgM: require(`../../assets/img/kcm_group/companies/9.jpg`),
          name: this.$t("kcm-companies-9-name"),
          title: this.$t("kcm-companies-9-title"),
          texts: this.$t("kcm-companies-9-texts"),
          url: "/kcm-group?page=companies&c=9",
          email: "luckyinvest@abv.bg",
          contacts: [
            {
              address: {
                url: "https://goo.gl/maps/5YKNKueqJDS2",
                text: this.$t("kcm-companies-9-contacts-1"),
              },
            },
            {
              phone: {
                url: "tel:+35930522046",
                text: "+35930522046",
              },
              email: {
                url: "mailto:luckyinvest@abv.bg",
                text: "luckyinvest@abv.bg",
              },
            },
          ],
          people: [
            {
              title: this.$t("kcm-companies-9-people-1"),
              list: [
                {
                  img: require("../../assets/img/kcm_group/companies/9/n_marudova.jpg"),
                  name: this.$t("kcm-companies-9-people-2"),
                  position: this.$t("kcm-companies-9-people-3"),
                },
                {
                  img: require("../../assets/img/kcm_group/companies/9/d_dalemski.jpg"),
                  name: this.$t("kcm-companies-9-people-9"),
                  position: this.$t("kcm-companies-9-people-7"),
                },
                {
                  img: require("../../assets/img/kcm_group/companies/no_img.jpg"),
                  name: this.$t("kcm-companies-9-people-8"),
                  position: this.$t("kcm-companies-9-people-7"),
                },
                {
                  img: require("../../assets/img/kcm_group/companies/9/e_shondrev.jpg"),
                  name: this.$t("kcm-companies-9-people-2-new"),
                  position: this.$t("kcm-companies-9-people-7"),
                },
                {
                  img: require("../../assets/img/kcm_group/companies/9/o_kutinchev.jpg"),
                  name: this.$t("kcm-companies-9-people-5-new"),
                  position: this.$t("kcm-group-companies-3-1"),
                },
              ],
            },
            {
              title: this.$t("kcm-group-companies-5"),
              list: [
                {
                  img: require("../../assets/img/kcm_group/companies/9/o_kutinchev.jpg"),
                  name: this.$t("kcm-companies-9-people-5-new"),
                  position: this.$t("kcm-group-companies-3-1"),
                },
              ],
            },
          ],
        },
        //VARBA-BATANCI
        {
          img: require(`../../assets/img/kcm_group/companies/10/bg.jpg`),
          imgM: require(`../../assets/img/kcm_group/companies/10.jpg`),
          name: this.$t("kcm-companies-10-name"),
          title: this.$t("kcm-companies-10-title"),
          texts: this.$t("kcm-companies-10-texts"),
          url: "/kcm-group?page=companies&c=10",
          email: "office@gorubsomadan.com",
          contacts: [
            {
              address: {
                url: "https://goo.gl/maps/pkgJ3wiigdrUHt7u7",
                text: this.$t("kcm-companies-10-contacts-1"),
              },
            },
            {
              phone: {
                url: "tel:+35930898004",
                text: "+359 30 898 004",
              },
              email: {
                url: "mailto:office@gorubsomadan.com",
                text: "office@gorubsomadan.com",
              },
            },
          ],
          people: [
            {
              title: this.$t("kcm-group-companies-3"),
              list: [
                {
                  img: require("../../assets/img/kcm_group/companies/10/tsonev.jpg"),
                  name: this.$t("kcm-companies-10-ppl-1-name"),
                  position: this.$t("kcm-companies-10-ppl-1-ttl"),
                },
                {
                  img: require("../../assets/img/kcm_group/companies/10/r_angelov.jpg"),
                  name: this.$t("kcm-companies-10-ppl-2-name"),
                  position: this.$t("kcm-companies-10-ppl-2-ttl"),
                },
                {
                  img: require("../../assets/img/kcm_group/companies/10/i_dobrev.jpg"),
                  name: this.$t("kcm-companies-10-ppl-3-name"),
                  position: this.$t("kcm-companies-10-ppl-3-ttl"),
                },
              ],
            },
            {
              title: this.$t("kcm-group-companies-4"),
              list: [
                {
                  img: require("../../assets/img/kcm_group/companies/10/a_kochian.jpg"),
                  name: this.$t("kcm-companies-10-ppl-4-name"),
                  position: this.$t("kcm-companies-10-ppl-4-ttl"),
                },
                {
                  img: require("../../assets/img/kcm_group/companies/10/a_Kyurkchiev.jpg"),
                  name: this.$t("kcm-companies-10-ppl-8-name"),
                  position: this.$t("kcm-companies-11-ppl-8-ttl"),
                },
                {
                  img: require("../../assets/img/kcm_group/companies/10/s_sirakov.jpg"),
                  name: this.$t("kcm-companies-10-ppl-6-name"),
                  position: this.$t("kcm-companies-10-ppl-6-ttl"),
                },
              ],
            },
            {
              title: this.$t("kcm-group-companies-5"),
              list: [
                // {
                //   img: require("../../assets/img/kcm_group/companies/10/s_atanasov.jpg"),
                //   name: this.$t("kcm-companies-10-ppl-5-name"),
                //   position: this.$t("kcm-companies-10-ppl-5-ttl-1"),
                // },
                {
                  img: require("../../assets/img/kcm_group/companies/10/s_sirakov.jpg"),
                  name: this.$t("kcm-companies-10-ppl-6-name"),
                  position: this.$t("kcm-companies-10-ppl-6-ttl-1"),
                },
                // {
                //   img: require("../../assets/img/kcm_group/companies/10/a_bairaktarov.jpg"),
                //   name: this.$t("kcm-companies-10-ppl-7-name"),
                //   position: this.$t("kcm-companies-10-ppl-7-ttl"),
                // },
              ],
            },
          ],
        },
        //BLZ METALIKON
        {
          img: require(`../../assets/img/kcm_group/companies/11/bg.jpg`),
          imgM: require(`../../assets/img/kcm_group/companies/11.jpg`),
          name: this.$t("kcm-companies-11-name"),
          title: this.$t("kcm-companies-11-title"),
          texts: this.$t("kcm-companies-11-texts"),
          url: "/kcm-group?page=companies&c=11",
          email: "Metalikon@kcm.bg",
          contacts: [
            {
              address: {
                url: "https://goo.gl/maps/HvTphJCd78t",
                text: this.$t("kcm-companies-11-contacts-1"),
              },
            },
            {
              email: {
                url: "mailto:Metalikon@kcm.bg",
                text: "Metalikon@kcm.bg",
              },
            },
          ],
        },
        {
          img: require(`../../assets/img/kcm_group/companies/12/bg.jpg`),
          imgM: require(`../../assets/img/kcm_group/companies/12.jpg`),
          name: this.$t("kcm-companies-12-name"),
          title: this.$t("kcm-companies-12-title"),
          texts: this.$t("kcm-companies-12-texts"),
          url: "/kcm-group?page=companies&c=12",
          email: "MCM@kcm.bg",
          contacts: [
            {
              address: {
                url: "https://goo.gl/maps/HvTphJCd78t",
                text: this.$t("kcm-companies-11-contacts-1"),
              },
            },
            {
              phone: {
                url: "tel:+35932609303",
                text: "+359 32 609 303",
              },
              email: {
                url: "mailto:MCM@kcm.bg",
                text: "MCM@kcm.bg",
              },
            },
          ],
        },
      ],
    };
  },
  methods: {
    scrollIntoForm() {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const el = document.getElementById("contactForm");
      // targetElement.scrollIntoView({ behavior: "smooth" });
      window.scrollTo({
        top: el.getBoundingClientRect().top + scrollTop - 100,
        behavior: "smooth",
      });
    },
  },
  mounted() {
    this.selectedCompany = +this.$route.query.c - 1;
  },
};
</script>

<style lang="scss" scoped>
.kcm-group-companies {
  align-items: flex-end;
  background-color: $mainColor3;
  display: flex;
  height: 100vh;
  .kcm-group-companies-content {
    display: flex;
    height: 100%;
    overflow: hidden;
    position: relative;
    width: 100%;
    .column {
      align-items: flex-end;
      display: flex;
      position: relative;
      width: 50%;
      z-index: 1;
      // IMAGE
      .company-img {
        background-size: cover;
        background-position: center;
        height: 100%;
        left: 40%;
        position: absolute;
        top: 0;
        width: 60%;
      }
      // CONTENT
      .company-inner {
        background-color: $bgColor4;
        display: flex;
        flex-direction: column;
        height: 100%;
        padding: 120px 0 0;
        position: relative;
        width: 100%;
        .company-inner-content {
          overflow: auto;
          padding: 0 50px;
          p {
            margin: 15px 0;
            a {
              font-size: 50px;
              display: flex;
            }
          }
          .people {
            background-color: rgba(178, 200, 210, 0.2);
            header {
              background-color: #b2c8d2;
              display: flex;
              justify-content: center;
              a {
                color: #22075e;
                margin: 0 15px;
                padding: 10px 0;
              }
              a:hover {
                opacity: 0.9;
              }
              .active-tab {
                font-weight: 500;
                text-decoration: underline;
              }
            }
            .people-content {
              display: flex;
              flex-wrap: wrap;
              justify-content: center;
              gap: 10px;
              padding: 10px;
              width: 100%;
            
              .people-item {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                width: calc(33% - 10px);

                .people-img {
                  background-color: #a8a8a8;
                  background-size: cover;
                  background-position: center;
                  height: 16vw;
                  width: 100%;
                }
                p,
                span {
                  display: block;
                  text-align: center;
                }
                p {
                  font-size: 14px;
                  font-weight: 500;
                  line-height: 18px;
                }
                span {
                  font-size: 10px;
                  opacity: 0.7;
                }
              }
            }
          }
        }
      }
    }
    .column:last-child {
      padding-bottom: 20px;
      padding-top: 70px;
      padding-right: $sidesPadding;
    }
  }
  .kcm-group-companies-content::before {
    background-color: $bgColor1;
    bottom: 0;
    content: "";
    height: 80%;
    left: 0;
    position: absolute;
    width: 100%;
  }
}

.mobile,
.companies-header {
  display: none;
}

@media screen and (max-width: 1600px) {
  .kcm-group-companies {
    .kcm-group-companies-content {
      .column:last-child {
        padding-right: $sidesPadding1600;
      }
    }
  }
  .company-inner-content {
    p {
      font-size: 14px;
      line-height: 18px;
    }
  }
}

@media screen and (max-width: 1440px) {
  .kcm-group-companies {
    .kcm-group-companies-content {
      .column {
        // CONTENT
        .company-inner {
          .company-inner-content {
            padding: 0 30px;
            p {
              margin: 10px 0;
            }
            .people {
              .people-content {
                .people-item {
                  p,
                  span {
                    display: block;
                    text-align: center;
                  }
                  p {
                    font-size: 12px;
                    line-height: 16px;
                  }
                  span {
                    font-size: 9px;
                    opacity: 0.7;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1376px) {
  .kcm-group-companies {
    .kcm-group-companies-content {
      .column {
        // CONTENT
        .company-inner {
          .company-inner-content {
            p {
              font-size: 12px;
              margin: 10px 0;
            }
            .people {
              header {
                a {
                  font-size: 12px;
                }
              }
              .people-content {
                .people-item {
                  p,
                  span {
                    display: block;
                    text-align: center;
                  }
                  p {
                    font-size: 11px;
                    line-height: 14px;
                  }
                  span {
                    font-size: 9px;
                    opacity: 0.7;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1280px) {
  .kcm-group-companies {
    .companies-header {
      display: block;
      position: absolute;
      top: 35px;
      @include transform(translateY(-50%));
      right: $sidesPadding1280;
      z-index: 2;
      h2,
      .contacts-header-form-button {
        display: none;
      }
      .companies-close {
        cursor: pointer;
        background-color: rgba(255, 255, 255, 0.1);
        padding: 10px;
      }
      .companies-close:hover {
        opacity: 0.8;
      }
    }
    .kcm-group-companies-content {
      .column {
        width: 35%;
        .company-img {
          left: $sidesPadding1280;
          width: 100%;
        }
      }
      .column:last-child {
        padding-right: $sidesPadding1280;
        width: 65%;
        .company-inner {
          .company-inner-content {
            .people {
              .people-content {
                .people-item {
                  .people-img {
                    height: 25vw;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 800px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
  .kcm-group-companies {
    background-color: $bgColor1;
    height: initial;
    flex-direction: column;
    .companies-header {
      align-items: center;
      display: flex;
      justify-content: space-between;
      padding: 15px;
      position: static;
      @include transform(initial);
      width: 100%;
      h2 {
        display: block;
        font-size: 24px;
        font-weight: 300;
        line-height: 28px;
      }
      .companies-header-buttons {
        align-items: center;
        display: flex;
        .contacts-header-form-button {
          align-items: center;
          background-color: #164194;
          border-radius: 50%;
          color: #fff;
          display: flex;
          font-size: 32px;
          height: 50px;
          justify-content: flex-end;
          padding: 10px;
          @include transition(all 0.6s $mainCubic);
          width: 50px;
        }
        .companies-close {
          background-color: transparent;
          padding: 0;
          margin-left: 15px;
          margin-right: 5px;
          span {
            font-size: 22px;
          }
        }
      }
    }
    .kcm-group-companies-content {
      height: initial;
      min-height: 100vh;
      overflow: hidden;
      flex-direction: column;
      .column {
        flex-direction: column;
        width: 100%;
        .company-img {
          left: 0;
          width: 100%;
        }
        .company-inner {
          padding: 0;
          .company-inner-content {
            padding: 15px;
          }
          .company-inner-content-hidden {
            display: none;
          }
        }
      }
      .column:first-child {
        margin-bottom: 60px;
      }
      .column:last-child {
        padding: 10px;
        width: 100%;
        .company-inner {
          .company-inner-content {
            .people {
              .people-content {
                .people-item {
                  .people-img {
                    height: 40vw;
                  }
                }
              }
            }
          }
        }
      }
    }
    .kcm-group-companies-content::before {
      display: none;
    }
  }
}
@media screen and (max-width: 600px) {
  .kcm-group-companies {
    .companies-header {
      h2 {
        font-size: 20px;
        line-height: 24px;
      }
    }
    // DON'T DO STUFF LIKE THAT KIDS :(
    .kcm-group-companies-content {
      .column:last-child {
        .company-inner {
          .company-inner-content {
            .people {
              .people-content {
                .people-item {
                  width: calc(50% - 10px);

                  .people-img {
                    height: 60vw;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 420px) {
  .kcm-group-companies {
    .companies-header {
      h2 {
        font-size: 16px;
        line-height: 20px;
      }
    }
  }
}
</style>

